class TableIconReplacer {
    constructor(config = {}) {
        const {} = config;

        this.symbol1 = [...document.querySelectorAll('.ally')].filter(html => html.innerText == 'symbol-1');
        this.symbol2 = [...document.querySelectorAll('.ally')].filter(html => html.innerText == 'symbol-2');
        this.symbol3 = [...document.querySelectorAll('.ally')].filter(html => html.innerText == 'symbol-3');
        this.symbol4 = [...document.querySelectorAll('.ally')].filter(html => html.innerText == 'symbol-4');

        if(this.symbol1.length > 0){
            this.changeSymbol(this.symbol1, "okay.png", "Ziel erreicht");
        }

        if(this.symbol2.length > 0){
            this.changeSymbol(this.symbol2, "check.png", "Auf Zielkurs");
        }

        if(this.symbol3.length > 0){
            this.changeSymbol(this.symbol3, "remove.png", "Nicht auf Zielkurs");
        }

        if(this.symbol4.length > 0){
            this.changeSymbol(this.symbol4, "close.png", "Ziel nicht erreicht");
        }
    }

    changeSymbol(symbols, img, alt){
        symbols.forEach(symbol => {
            let th = symbol.closest('td') ? symbol.closest('td') : symbol.closest('th');
            th.classList.add('ns-symbol-container');
            th.removeChild(th.firstElementChild);
            let symbolImage = document.createElement('img');
            symbolImage.setAttribute('src', window.location.origin + '/2022/app/themes/bekb-ar-theme/dist/images/' + img);
            symbolImage.setAttribute('alt', alt);
            symbolImage.setAttribute('title', 'Icon, ' + alt);
            symbolImage.setAttribute('class', 'ns-symbol');
            th.append(symbolImage);
        });
    }

}

export default TableIconReplacer;
